import { Injectable } from '@angular/core';

// Internal services
import { BaseHttpService } from '../base-http-service.service';
import { AuthInterceptorService } from 'src/app/interceptors/auth.interceptor';

// Internal models
export interface PhoneValidationResult {
  lineType: 'Mobile' | 'LikelyLandline' | 'DefinitelyLandline' | 'Unknown';
  source: string;
  details: string | null;
  normalizedPhone: string | null;
  shouldWarn: boolean;
  shouldBlockSend: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PhoneValidationService extends BaseHttpService {
  constructor(authInterceptor: AuthInterceptorService) {
    super(authInterceptor);
  }

  // ! GET Requests

  /**
   * Validate a phone number for SMS capability (landline detection).
   * Returns null on any error — callers should treat null as "no warning".
   */
  async validatePhone(phoneNumber: string, countryCode: string = 'US'): Promise<PhoneValidationResult | null> {
    // Spotlite is served through the 2286 proxy, which mounts only the *-proxy prefixes (no bare
    // /api) and attaches the venue-level bearer the [Authorize] endpoint requires — a public page
    // has no JWT of its own, so the bare /api path both 404s at the proxy and would 401 anyway.
    const endpoint = `/spotlite-proxy/Guest/validate-phone?phoneNumber=${encodeURIComponent(phoneNumber)}&countryCode=${encodeURIComponent(countryCode)}`;
    return this.get<PhoneValidationResult>(endpoint);
  }
}
